module.exports = __webpack_public_path__ + "static/jd_cafe_story-de4f378b178ccd4ae8d352dafb2e5688.png";